const businessTypes = {
	CREATE_BUSINESS: {
		REQUEST: 'CREATE_BUSINESS_REQUEST',
		SUCCESS: 'CREATE_BUSINESS_SUCCESS',
		FAILURE: 'CREATE_BUSINESS_FAILURE',
		CLEAR: 'CREATE_BUSINESS_CLEAR',
	},
	CATEGORIES: {
		REQUEST: 'BUSINESS_CATEGORIES_REQUEST',
		SUCCESS: 'BUSINESS_CATEGORIES_SUCCESS',
		FAILURE: 'BUSINESS_CATEGORIES_FAILURE',
		CLEAR: 'BUSINESS_CATEGORIES_CLEAR',
	},
	GET_BUSINESS: {
		REQUEST: 'BUSINESS_GET_BUSINESS_REQUEST',
		SUCCESS: 'BUSINESS_GET_BUSINESS_SUCCESS',
		FAILURE: 'BUSINESS_GET_BUSINESS_FAILURE',
		CLEAR: 'BUSINESS_GET_BUSINESS_CLEAR',
	},
	GET_BUSINESS_List: {
		REQUEST: 'GET_BUSINESS_List_REQUEST',
		SUCCESS: 'GET_BUSINESS_List_SUCCESS',
		FAILURE: 'GET_BUSINESS_List_FAILURE',
		CLEAR: 'GET_BUSINESS_List_CLEAR',
	},
	RATEANDREVIEW: {
		REQUEST: 'BUSINESSRATEANDREVIEW_REQUEST',
		SUCCESS: 'BUSINESSRATEANDREVIEW_SUCCESS',
		FAILURE: 'BUSINESSRATEANDREVIEW_FAILURE',
		CLEAR: 'BUSINESSRATEANDREVIEW_CLEAR',
	},
	BUSINESSITEM: {
		REQUEST: 'BUSINESSITEM_REQUEST',
		SUCCESS: 'BUSINESSITEM_SUCCESS',
		FAILURE: 'BUSINESSITEM_FAILURE',
		CLEAR: 'BUSINESSITEM_CLEAR',
	},
	BUSINCOMMISION: {
		REQUEST: 'BUSINESSCOMMISION_REQUEST',
		SUCCESS: 'BUSINESSCOMMISION_SUCCESS',
		FAILURE: 'BUSINESSCOMMISION_FAILURE',
		CLEAR: 'BUSINESSCOMMISION_CLEAR',
	},
	UPDATE: {
		REQUEST: 'BUSINESS_UPDATE_REQUEST',
		SUCCESS: 'BUSINESS_UPDATE_SUCCESS',
		FAILURE: 'BUSINESS_UPDATE_FAILURE',
		CLEAR: 'BUSINESS_UPDATE_CLEAR',
	},
	CONTRACT_LINK: {
		REQUEST: 'BUSINESS_CONTRACT_LINK_REQUEST',
		SUCCESS: 'BUSINESS_CONTRACT_LINK_SUCCESS',
		FAILURE: 'BUSINESS_CONTRACT_LINK_FAILURE',
		CLEAR: 'BUSINESS_CONTRACT_LINK_CLEAR',
	},
	CONTRACT_BUSINESS_INFO: {
		REQUEST: 'CONTRACT_BUSINESS_INFO_REQUEST',
		SUCCESS: 'CONTRACT_BUSINESS_INFO_SUCCESS',
		FAILURE: 'CONTRACT_BUSINESS_INFO_FAILURE',
		CLEAR: 'CONTRACT_BUSINESS_INFO_CLEAR',
	},
	SIGN: {
		REQUEST: 'BUSINESS_SIGN_REQUEST',
		SUCCESS: 'BUSINESS_SIGN_SUCCESS',
		FAILURE: 'BUSINESS_SIGN_FAILURE',
		CLEAR: 'BUSINESS_SIGN_CLEAR',
	},
	PACKAGES: {
		REQUEST: 'BUSINESS_PACKAGES_REQUEST',
		SUCCESS: 'BUSINESS_PACKAGES_SUCCESS',
		FAILURE: 'BUSINESS_PACKAGES_FAILURE',
		CLEAR: 'BUSINESS_PACKAGES_CLEAR',
	},
	SUPER_BUSINESS: {
		REQUEST: 'BUSINESS_SUPER_BUSINESS_REQUEST',
		SUCCESS: 'BUSINESS_SUPER_BUSINESS_SUCCESS',
		FAILURE: 'BUSINESS_SUPER_BUSINESS_FAILURE',
		CLEAR: 'BUSINESS_SUPER_BUSINESS_CLEAR',
	},
	GET_CASHIER_MACHINES: {
		REQUEST: 'BUSINESS_GET_CASHIER_MACHINES_REQUEST',
		SUCCESS: 'BUSINESS_GET_CASHIER_MACHINES_SUCCESS',
		FAILURE: 'BUSINESS_GET_CASHIER_MACHINES_FAILURE',
	},
	GET_CONTRACT: {
		REQUEST: 'GET_CONTRACT_REQUEST',
		SUCCESS: 'GET_CONTRACT_SUCCESS',
		FAILURE: 'GET_CONTRACT_FAILURE',
	},
	SIGN_CONTRACT_WITHOUT_TOKEN: {
		REQUEST: 'SIGN_CONTRACT_WITHOUT_TOKEN_REQUEST',
		SUCCESS: 'SIGN_CONTRACT_WITHOUT_TOKEN_SUCCESS',
		FAILURE: 'SIGN_CONTRACT_WITHOUT_TOKEN_FAILURE',
	},
};

export default businessTypes;
